<script setup>
import {onBeforeMount, ref, onMounted} from "vue";
import {useStore} from 'vuex'
import {useRoute} from "vue-router";


const store = useRoute()
const route = useStore()
import {wsClient} from "@/socket";
import {ProjectApi} from "@/api/project";


const projects = ref([])
const ico_page = {
  "reviews": "chat-right-heart",
  "massmedia": "file-earmark-text-fill",
  "wikipedia": "wikipedia",
  "socials": "messenger",
  "cp": "person-fill",
  "contents": "pencil-fill",
  "targets": "bullseye",
  "psychotype": "people",
  "comments": "wechat",
  "agents": "person-gear",
  "monitoring": "globe-americas",
  "seo": "graph-up-arrow",
  "tonality": "signpost-split",
  "extraction": "journal-x",
  "reviews_monitor": "person-hearts",
}


onMounted(() => {
  ProjectApi.list(true).then(projects => projects.value = projects.results);

  wsClient.connectWs('user_events')
})

onBeforeMount(() => {
  document.querySelectorAll(".menu .link-dark.rounded").forEach(item => {
    item.addEventListener('click', () => {
      document.getElementById('sidebarMenu').classList.remove("show");
    })
  })
})

function toggleMenu(_id, e) {
  e.preventDefault()
  e.target.classList.toggle('bi-chevron-down')
  e.target.classList.toggle('bi-chevron-up')
  document.getElementById(_id).classList.toggle('open')
}

function logout() {
  store.dispatch('logout')
      .then(() => {
        route.push('/login')
      })
}

</script>

<template>
  <nav :class="`pb-4 text-white sidebar ${!$store.getters.sidebar_state?'':'collapse'}`">
    <div class="hide-sidebar" style="z-index: 2" @click="$store.dispatch('toggle_sidebar')">
      <i :class="`bi bi-chevron-double-${$store.getters.sidebar_state?'right':'left'}`"></i>

    </div>
    <div class="menu-group mt-4">
      <template v-for="page in $store.getters.pages">
        <template v-if="page.app === 'profile'">

          <router-link active-class="active" class="btn btn-menu" :title="page.name" to="/" exact>
            <i :class="'bi bi-'+ico_page[page.slug]"></i>
            <span>Цифровой профиль</span>
            <span><i class="bi bi-chevron-down" @click="toggleMenu('project_menu', $event)"></i></span>
          </router-link>

          <div id="project_menu" class="filter">
            <ul>
              <li v-for="project in projects">
                <router-link active-class="active" class="text-white" :to="`/projects/${project.id}/`">
                  {{ project.name }}
                </router-link>

              </li>
            </ul>
          </div>

        </template>
        <template v-else>
          <router-link active-class="active" class="btn btn-menu" :title="page.name" :to="`/${page.slug}/`">
            <i :class="'bi bi-'+ico_page[page.slug]"></i>
            <span> {{ page.name }}</span>
          </router-link>
        </template>
      </template>
      <a href="#" @click.prevent="logout" title="Выход" class="no-wrap btn btn-outline-primary btn-sm rounded-5 logout">
        Выход
      </a>

    </div>


  </nav>

</template>

<style>
.child-menu {
  border-left: 1px solid #363535;
  padding-left: 5px !important;
  margin-left: 5px;
  padding-top: 10px;
}
</style>